// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":root{--label-font-size:14px;--test-color:#fff}._3Ykk0{font-size:var(--size-static-200);line-height:var(--size-static-400)}", ""]);
// Exports
exports.locals = {
	"eighthNoteIcon": "_3Ykk0"
};
module.exports = exports;
